import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cm from 'helpers/commons';
import { Modal, Button, Accordion, Icon } from 'semantic-ui-react';
import { BillInfo, BillItems } from 'components/Bill';

const propTypes = {
  modalFn: PropTypes.object.isRequired,
  billDtl: PropTypes.object,
  salesSum: PropTypes.number,
  companySum: PropTypes.number
};

const defaultProps = {
  billDtl: null,
  billDtlIndex: 0,
  salesSum: null,
  companySum: null
};

class RejectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: [0],
      currentKey: 1
    };
  }

  handleClick = (e, index) => {
    const { activeIndex, currentKey } = this.state;
    const { getRejectInvoices } = this.props.modalFn;
    const modal = document.getElementById('modalContent');
    const newIndex =
      activeIndex.indexOf(index) === -1 ? [...activeIndex, index] : activeIndex.filter((item) => item !== index);

    if (activeIndex !== index) {
      this.setState({ activeIndex: newIndex });
      getRejectInvoices(index);
    }

    this.setState({ currentKey: currentKey === index ? -1 : index });
    modal.scrollTop = 0;
  };

  render() {
    const { activeIndex, currentKey } = this.state;
    const { modalFn, billDtl, billDtlIndex } = this.props;
    const { open, close } = modalFn;

    const panels = [];
    let isOpen = false;

    return (
      <Modal className="modal-large" open={open} onClose={close}>
        <Modal.Header>폐기된 청구서</Modal.Header>
        <StyledModalContent id="modalContent">
          <Accordion fluid styled className="modal-rejected">
            <div>
              {billDtl.data.invoices.map((invoice, idx) => {
                const { billingAccountName, date, invoiceIdx } = invoice.detail;
                const invoiceDate = cm.yyyyMMdd(date.invoiced);

                if (idx === 0) {
                  return;
                }

                let salesSum = null;
                let companySum = null;
                if (invoice.usageHistoryTotal) {
                  const { usageHistoryTotal } = invoice;
                  salesSum = usageHistoryTotal.totalSales;
                  companySum = usageHistoryTotal.totalPrice;
                }

                return (
                  <div key={idx}>
                    <StyledAccordionTitle index={idx} onClick={(e) => this.handleClick(e, idx)}>
                      <StyledIcon name="plus" />
                      <a
                        href="#modalContent"
                        style={{
                          display: 'inline-block',
                          cursor: `${isOpen !== idx ? 'pointer' : 'default'}`
                        }}
                      >
                        <StyledTitle>
                          <StyledSpan>{billingAccountName}</StyledSpan>
                          <StyledSpan>{invoiceDate.substring(5, 7)}월</StyledSpan>
                          <StyledSpan>{invoiceDate.substring(8, 10)}일</StyledSpan>
                          <StyledSpan>
                            청구서(
                            {invoiceIdx})
                          </StyledSpan>
                        </StyledTitle>
                      </a>
                    </StyledAccordionTitle>
                    <Accordion.Content active={currentKey === idx}>
                      <StyledContent>
                        <BillInfo
                          detail={invoice.detail}
                          approval={invoice.approval}
                          items={invoice.usageHistoryTotal}
                          salesSum={salesSum}
                          companySum={companySum}
                          billDtlIndex={billDtlIndex}
                        />
                      </StyledContent>
                      <StyledContent>
                        <BillItems items={invoice.usageHistoryTotal} salesSum={salesSum} companySum={companySum} />
                      </StyledContent>
                    </Accordion.Content>
                  </div>
                );
              })}
            </div>
          </Accordion>
        </StyledModalContent>

        <Modal.Actions>
          <Button positive onClick={close} content="닫기" />
        </Modal.Actions>
      </Modal>
    );
  }
}

RejectModal.propTypes = propTypes;
RejectModal.defaultProps = defaultProps;

const StyledAccordionTitle = styled(Accordion.Title)`
  /* position: relative;
  padding: 0 !important;
  cursor: default !important; */
  border-bottom: 1px solid #dcdcdc;
`;

const StyledContent = styled.section`
  padding: 1rem;
`;

const StyledIcon = styled(Icon)`
  position: relative;
  top: -2px;
  left: 0;
  font-size: 24px !important;
  color: #383838;
  vertical-align: middle;
`;

const StyledTitle = styled.div`
  display: inline-block;
  font-size: 14px;
  color: #383838;
  vertical-align: middle;
`;

const StyledSpan = styled.span`
  margin-left: 4px;
  :first-child {
    margin-left: 0;
  }
`;

const StyledModalContent = styled(Modal.Content)`
  &&&& {
    height: 600px;
    overflow: auto;
  }
`;

export default RejectModal;
